const branding = {
  ENERGIC: 'energic',
  VOLTIE: 'voltie',
};

const ocppMessageType = {
  RMT_START_TRANSACTION: 'rmt-start-transaction',
  RMT_STOP_TRANSACTION: 'rmt-stop-transaction',
  EC_METER_VALUE: 'ec-meter-value',
  EC_NO_OPERATION: 'ec-no-operation',
  WC_UPDATE_TRANSACTION_ID: 'wc-update-transaction-id',
  RESET_CP: 'reset-cp',
  ADD_REMOVE_RFID_CARD: 'add-remove-rfid-card',
  CHANGE_CONFIGURATION: 'change-configuration',
  CHANGE_CONFIGURATION_CUSTOM: 'change-configuration-custom',
  CHANGE_AVAILABILITY: 'change-availability',
  CLEAR_CACHE: 'clear-cache',
  GET_CONFIGURATION: 'get-configuration',
  UNLOCK_CONNECTOR: 'unlock-connector',
  SUPER_ADMIN_COMMANDS: 'super-admin-commands',
  GET_COMPOSITE_SCHEDULE: 'get-composite-schedule',
  RESERVE_NOW: 'reserve-now',
  CANCEL_RESERVATION: 'cancel-reservation',
  SEND_LOCAL_LIST: 'send-local-list',
  GET_DIAGNOSTICS: 'get-diagnostics',
  GET_LOCAL_LIST_VERSION: 'get-local-list-version',
  UPDATE_FIRMWARE: 'update-firmware',
  TRIGGER_MESSAGE: 'trigger-message',
  SET_CHARGING_PROFILE: 'set-charging-profile',
  CLEAR_CHARGING_PROFILE: 'clear-charging-profile',
};

const filterType = {
  DATE: 'date',
  TEXT: 'text',
  CHECKBOX: 'checkbox',
  RADIO_BUTTON: 'radio-button',
  SELECT_FIELD: 'list',
  DATE_RANGE: 'dateRange',
  TIME_RANGE: 'timeRange',
  MULTISELECT: 'multiSelect',
  ANGLE_BRACKETS: 'angleBrackets',
} as const; // Prevents additional modification

// Define the type based on filterType object
type FilterType = (typeof filterType)[keyof typeof filterType];

const allStatus = {
  REJECTED: 'rejected',
  PENDING: 'pending',
  FINISHED: 'finished',
  INPROGRESS: 'inProgress',
  ACCEPTED: 'Accepted',
  AVAILABLE: 'Available',
  PREPARING: 'Preparing',
  FINISHING: 'Finishing',
  FAULTED: 'Faulted',
  CHARGING: 'Charging',
};

const chartTimePeriod: {
  label: string;
  value: 'last24hours' | 'last7days' | 'lastMonth' | 'last12months';
}[] = [
    {
      label: '24 hours',
      value: 'last24hours',
    },
    {
      label: '7 Days',
      value: 'last7days',
    },
    {
      label: 'Last Month',
      value: 'lastMonth',
    },
    {
      label: '12 Months',
      value: 'last12months',
    },
  ];

const connectorStatus = {
  AVAILABLE: 'Available',
  PREPARING: 'Preparing',
  FINISHING: 'Finishing',
  CHARGING: 'Charging',
  SUSPENDED_EVSE: 'SuspendedEVSE',
  SUSPENDED_EV: 'SuspendedEV',
  RESERVED: 'Reserved',
  UNAVAILABLE: 'Unavailable',
  FAULTED: 'Faulted',
};

const chargerType = {
  Personal: 'Personal',
  Commercial: 'Commercial',
};

export {
  branding,
  ocppMessageType,
  filterType,
  FilterType,
  allStatus,
  chartTimePeriod,
  connectorStatus,
  chargerType,
};
